import script from "./ControlBox.vue?vue&type=script&setup=true&lang=js"
export * from "./ControlBox.vue?vue&type=script&setup=true&lang=js"

import "./ControlBox.vue?vue&type=style&index=0&id=1a2406bd&scoped=true&lang=css"

import exportComponent from "/home/forge/konfigurator.loewe-zaun.de/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a2406bd"]])

export default __exports__